import { useState, useEffect } from "react";

const STORAGE_KEY = "alphasignal-theme";

export function useThemeMode() {
  const [isDark, setIsDark] = useState<boolean>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    // Default to light when nothing has been stored yet.
    return (stored ?? "light") === "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add("dark");
      localStorage.setItem(STORAGE_KEY, "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem(STORAGE_KEY, "light");
    }
  }, [isDark]);

  // Sync on mount from storage (in case ThemeProvider set it)
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    const shouldBeDark = (stored ?? "light") === "dark";
    setIsDark(shouldBeDark);
    document.documentElement.classList.toggle("dark", shouldBeDark);
  }, []);

  const toggle = (val: boolean) => setIsDark(val);

  return { isDark, toggle };
}
